import React, { useState } from 'react';

interface NewPlayerInlineProps {
  toggleLabel: string;
  submitLabel: string;
  testIdPrefix: string;
  onSubmit: (fullName: string) => void;
}

export function NewPlayerInline({
  toggleLabel,
  submitLabel,
  testIdPrefix,
  onSubmit,
}: NewPlayerInlineProps): JSX.Element {
  const [expanded, setExpanded] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const canSubmit = firstName.trim().length > 0 && lastName.trim().length > 0;

  function confirm(): void {
    if (!canSubmit) {
      return;
    }

    onSubmit(`${firstName.trim()} ${lastName.trim()}`);
    setExpanded(false);
    setFirstName('');
    setLastName('');
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>): void {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();
    confirm();
  }

  if (!expanded) {
    return (
      <button
        type="button"
        className="new-player__toggle"
        onClick={() => setExpanded(true)}
        data-testid={`${testIdPrefix}-toggle`}
      >
        <span className="new-player__toggle-plus" aria-hidden="true">+</span>
        {toggleLabel}
      </button>
    );
  }

  return (
    <div className="new-player-inline" data-testid={`${testIdPrefix}-form`}>
      <div className="new-player-inline__fields">
        <label className="new-player-inline__field">
          <span className="new-player-inline__label">Imię</span>
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            onKeyDown={handleKeyDown}
            data-testid={`${testIdPrefix}-first-name`}
            autoComplete="off"
            spellCheck={false}
          />
        </label>
        <label className="new-player-inline__field">
          <span className="new-player-inline__label">Nazwisko</span>
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            onKeyDown={handleKeyDown}
            data-testid={`${testIdPrefix}-last-name`}
            autoComplete="off"
            spellCheck={false}
          />
        </label>
      </div>
      <div className="new-player-inline__actions">
        <button
          type="button"
          className="new-player-inline__submit"
          onClick={confirm}
          disabled={!canSubmit}
          data-testid={`${testIdPrefix}-submit`}
        >
          {submitLabel}
        </button>
        <button
          type="button"
          className="btn-link"
          onClick={() => setExpanded(false)}
          data-testid={`${testIdPrefix}-cancel`}
        >
          Anuluj
        </button>
      </div>
    </div>
  );
}
